const storeTypes = {
  DEFAULT: 0,
  ECOM_DASH: 1,
  CTCT_SHOPPABLE_LANDING: 2
}

export default storeTypes
